import { useAuthStore } from "@/store/auth"
import { useOperationSupportStore } from "@/store/operation-support"
import axios from "axios"
//import { useOperationSupportStore } from "@/store/operation-support"
import dayjs, { Dayjs } from "dayjs"
import { isError, isString } from "lodash"

export class OperationSupportLog {
  traceId: string | null = null
  userId: number | null = null // 未ログイン時はnullのまま
  staffName: string | null = null // 未ログイン時はnullのまま
  staffCode: string | null = null // 未ログイン時はnullのまま
  device: string | null = null
  os: string | null = null
  osVersion: string | null = null
  appVersion: string | null = null
  buildNumber: number | null = null
  originType: string = 'Vue' // 発生元（ひとまずLaravel、Vue、Mobileがあるという想定で）
  screenName: string | null = null // 発生した画面名（任意の表記でOK）
  operationName: string | null = null // 操作内容など（任意の表記でOK）
  message: string | null = null // 任意のメッセージ）
  systemMessage: string | null = null // フレームワーク側からのエラーメッセージなどの記録用
  originDateTime: string = dayjs().format('YYYY-MM-DD H:M:ss')
  enableCookie: boolean = window.navigator.cookieEnabled
  language: string = window.navigator.language // 基本はjaだが念のため
  screenWidth: number = screen.width // 表示サイズ（デバイスpxではなくCSSpx）
  screenHeight: number = screen.height // 表示サイズ（デバイスpxではなくCSSpx）
  userAgent: string = window.navigator.userAgent

  constructor() {
    const authStore = useAuthStore()
    const opSupportStore = useOperationSupportStore()
    this.traceId = opSupportStore.traceId
    this.userId = authStore.user?.user_id ? authStore.user.user_id : null
    this.staffName = authStore.user?.staff_name ? authStore.user.staff_name : null
    this.staffCode = authStore.user?.staff_code ? authStore.user.staff_code : null

    this.device = opSupportStore.device
    this.os = opSupportStore.os
    this.osVersion = opSupportStore.osVersion
    this.appVersion = opSupportStore.appVersion
    this.buildNumber = opSupportStore.buildNumber
  }

  /**
   * ユーザー情報をセットします
   * 通常インスタンス生成時にauthStoreからセットされるため実行する必要はありません。
   * 「authStoreには情報が無いがユーザーIDなどは分かる」という状況で適宜使用してください
   */
  public async setUserInfo(userId: number | null, staffName: string | null = null, staffCode: string | null = null) {
    if (userId) {
      this.userId = userId
    }
    
    if (staffName) {
      this.staffName = staffName
    }

    if (staffCode) {
      this.staffCode = staffCode
    }
  }

  /**
   * ログメッセージ等の情報をセットします
   */
  public async setLogInfo(screen: string, operationName: string, message: string | null = null, systemMessageObj: any = null) {
    this.screenName = screen
    this.operationName = operationName
    this.message = message

    if (isError(systemMessageObj)) {
      this.systemMessage = systemMessageObj.message
    } else if (isString(systemMessageObj)) {
      this.systemMessage = systemMessageObj
    } else if (!systemMessageObj) {
      this.systemMessage = systemMessageObj
    } else {
      this.systemMessage = 'エラーオブジェクトの型を推測できませんでした'
    }

  }
}